<script setup>
    import storage from '@/libs/storage';
    import { useRoute,useRouter } from 'vue-router';
    import { storeToRefs } from 'pinia';
    import { useUserStore } from "@/store/modules/user";
    import { useAppStore } from "@/store/modules/app";
    import { isEmpty,inArray } from "@/libs/utils";

    const route            = useRoute();
    const router 		   = useRouter();
    const userStore 	   = useUserStore();
    const appStore         = useAppStore();
    const { isLogin,user } = storeToRefs(userStore);
    const { site }         = storeToRefs(appStore);
    const query            = route.query;
    
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
    const onHandleLang = (value)=>{
        let array = [];
        let url = window.location.href.split("?")[0];
        for(let index in query){
            if(!inArray(index,["lang"])){
                array.push(index+"="+query[index]);
            }
        }
        
        storage.set("lang",value.code);
        array.push("lang="+value.code);
        window.location.href = url + "?" + array.join("&");
    }

    const logout = ()=>{
        userStore.logout();
        router.replace("/");
    }
    
    const getLink = (value)=>{
        let array = value.split("=");
        return array[1];
    }

</script>

<template>
    <div class="top-wrap" :style="{ height: props.data.height_style + 'px', backgroundColor: props.data.background_color, borderColor: props.data.border_color }">
        
        <div class="top-box" :style="{ color: props.data.text_color }">
            <div class="left" v-if="props.data.data[0] != undefined">
                <template v-if="!isLogin">
                    <span>{{ props.data.data[0].tips || "" }}</span>
                    <span v-for="(value,index) in props.data.data[0].list" :key="index">
                        <a :href="getLink(value.link.path)" target="_blank" v-if="value.link.params.type == 'link'">{{ value.title || "" }}</a>
                        <a-link v-else :to="value.link.path">{{ value.title || "" }}</a-link>
                    </span>
                </template>
                <template v-else-if="user != null">
                    <span><a-link to="/ucenter/index">{{ $t("components.design.top.welcome") }}，{{ user.username || "" }}</a-link></span>
                    <span style="margin-left: 20px;" @click="logout">{{ $t("components.design.top.logout") }}</span>
                </template>
            </div>
            
            <div class="right" v-if="props.data.data[1] != undefined">
                <span v-for="(value,index) in props.data.data[1].list" :key="index">
                    <a-link :to="value.link.path">{{ value.title || "" }}</a-link>
                </span>
                <div class="lang-box">
                    <el-dropdown>
                        <div class="lang-current-box">
                            <img :src="site.lang.current.image" />
                            <span>
                                {{ site.lang.current.name }}
                                <el-icon>
                                    <arrow-down />
                                </el-icon>
                            </span>
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item v-for="(value,index) in site.lang.list" :key="index" @click="onHandleLang(value)">
                                    <div class="lang-item-box">
                                        <img :src="value.image" />
                                        <span>{{ value.name }}</span>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
:deep(.el-tooltip__trigger:focus-visible) {
    outline: unset;
}
.lang-box {
    display: inline-block;
    display: flex;
    align-items: center;
    font-size: 13px;
    .lang-current-box {
        img {
            width: 20px;
            height: 12px;
            padding-right: 5px;
            padding-top: 3px;
        }
        span {
            font-size: 13px;
            cursor: pointer;
        }
    }
}
.lang-item-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    img {
        width: 20px;
        height: 12px;
        padding-right: 5px;
    }
    span {
        font-size: 13px;
    }
}
.top-wrap {
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    background-color: #fff;
    .top-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        color: #333;
        .left {
            span {
                margin-left: 30px;
                cursor: pointer;
                &:hover {
                    color: #dc143c;
                }
                a {
                    color: #333;
                    text-decoration: none;
                    font-size: 13px;
                    &:hover {
                        color: #dc143c;
                    }
                }
                &:first-child {
                    margin-left: 0;
                }
            }
        }
        .right {
            display: flex;
            align-items: center;
            span {
                margin-right: 30px;
                a {
                    color: #333;
                    text-decoration: none;
                    font-size: 13px;
                    &:hover {
                        color: #dc143c;
                    }
                }
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>